import React from "react";
import { SearchContext } from "./contextProvider";

function useSearchContext() {
  const context = React.useContext(SearchContext);

  return context;
}

export default useSearchContext;
